"use strict";
exports.__esModule = true;
var TextareaAutosize_1 = require("./TextareaAutosize");
exports["default"] = TextareaAutosize_1["default"];



//////////////////
// WEBPACK FOOTER
// ./~/react-autosize-textarea/lib/index.js
// module id = 1169
// module chunks = 168707334958949